import { tutorHandlers } from './tutor-handlers';
import { tutorSearchHandlers } from './tutor-search-handlers';
import { tutorTagCloudHandlers } from './tag-cloud';

const allTutorHandlers = () => {
    tutorHandlers();
    tutorSearchHandlers();
    tutorTagCloudHandlers();
}

export default allTutorHandlers;
